import { render, staticRenderFns } from "./warehouseLabel.vue?vue&type=template&id=a64c03d0&scoped=true&"
import script from "./warehouseLabel.vue?vue&type=script&lang=js&"
export * from "./warehouseLabel.vue?vue&type=script&lang=js&"
import style0 from "./warehouseLabel.vue?vue&type=style&index=0&id=a64c03d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64c03d0",
  null
  
)

export default component.exports